import $ from 'jquery';

class cdpInsightMostPopularRetailPlace{
  constructor() {
    if ($('#cdp-insight-most-popular-retail-place').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-most-popular-retail-place').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    if (response.profiles_count !== 0) {
      $('#cdp-insight-most-popular-retail-place #retaler-name').text(response.contragent_name);
      $('#cdp-insight-most-popular-retail-place #retaler-name').attr('href', `${location.origin}/contragents/${response.contragent_id}`);
      $('#cdp-insight-most-popular-retail-place #retaler-name').attr('target', '_blank');
      $('#cdp-insight-most-popular-retail-place #retail-place-map').text(response.retail_place_address);
      $('#cdp-insight-most-popular-retail-place #retail-place-map').attr('href', `${location.origin}/contragents/${response.contragent_id}/retail_places/${response.retail_place_uid}/map`);
      $('#cdp-insight-most-popular-retail-place #retail-place-map').attr('target', '_blank');
      $('#cdp-insight-most-popular-retail-place #profiles-count').text(this.transform(response.profiles_count));
      $('#cdp-insight-most-popular-retail-place #receipts-count').text(this.transform(response.receipts_count));
      $('#cdp-insight-most-popular-retail-place .card-body .ml-2 h4').text(this.transform(response.profiles_count));
      $('#cdp-insight-most-popular-retail-place .open-new-insight-segment-modal').attr('data-scope', `with_retail_place`);
      $('#cdp-insight-most-popular-retail-place .open-new-insight-segment-modal').attr('data-args', `${response.retail_place_uid}`);
      $('#cdp-insight-most-popular-retail-place .peity-donut').text(`${response.profiles_percentage}/100`);
      $('#cdp-insight-most-popular-retail-place .peity-donut').peity('donut');
    }else{
      $('#cdp-insight-most-popular-retail-place #most-popular-retail-place-body').html("Нет данных")
      $('#cdp-insight-most-popular-retail-place .card-body .ml-2 h4').text(this.transform(response.profiles_count));
      $('#cdp-insight-most-popular-retail-place .peity-donut').text(`${response.profiles_percentage}/100`);
      $('#cdp-insight-most-popular-retail-place .peity-donut').peity('donut');
    }
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-most-popular-retail-place .open-new-insight-segment-modal').removeClass('d-none');
    } else {
      $('#cdp-insight-most-popular-retail-place .open-new-insight-segment-modal').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-most-popular-retail-place').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-most-popular-retail-place').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightMostPopularRetailPlace;